import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { INotification } from './interfaces';

const basePath = '/notifications';

export const getAll = <T>(): AxiosPromise<IApiResponse<Array<INotification>>> => vaultApi.getInstance().get(basePath);

export const getById = <T>(id: string): AxiosPromise<IApiResponse<INotification>> => vaultApi.getInstance().get(`${basePath}/${id}`);
